var Mustache = require('mustache');

export default {
    init() {
        this.initMoneyTable();
        this.initMoneyEdits();
        this.initMoneyDeletes();
        this.initMoneyAdds();
        this.initShowInfo();
        this.initFormModal('sales');
        this.initFormModal('fixed-expenses');
        this.initFormModal('flexed-expenses');
        this.initSettingsMoneyItem();
        this.changeValueType();
    },
    finalize() {
    },
    initMoneyTable() {
        let $this = this;
        $('body').on('focusout', '.money-table input', function () {
            $this.moneyMonth($(this));
        });
        $('body').on('keyup', '.money-table input', function (e) {
            if (e.keyCode == 13) {
                $this.moneyMonth($(this));
            }
        });
        $('body').on('click', '.money-table .money-item', function () {
            if ($(this).siblings().val().trim() == 0) {
                $(this).siblings().val('');
            } else {
                $(this).siblings().val($(this).siblings().val().trim());
            }
            $(this).siblings().css('display', 'block').focus();
            $(this).css('display', 'none');
        });
    },
    initMoneyEdits() {
        const $editItem = $('.money-table .edit-money-item');

        if ($editItem.length) {
            $('body').on('click', '.money-table .edit-money-item', function (e) {
                let $elem = $(this);
                e.preventDefault();
                e.stopPropagation();
                $.ajax({
                    type: 'GET',
                    url: '/money/money_item',
                    data: ({
                        id: $elem.data('id'),
                    }),
                    success: function (response) {
                        let item = response.money_item;
                        if (item) {
                            let form_id = $elem.data('form');
                            $('.form-validation-errors').html('');
                            //this is to refresh form with items
                            switch (form_id) {
                                case 'sales':
                                    $('#sales-money-form-modal #sales-money-form-modal-title').text('Edit Sales / Revenue');
                                    $('#sales-money-form-modal input[name="id"]').val(item.id);
                                    $('#sales-money-form-modal input[name="title"]').val(item.title);
                                    $('#sales-money-form-modal textarea[name="comment"]').val(item.comment);
                                    $('#sales-money-form-modal').modal('show');
                                    break;
                                case 'fixed_expenses':
                                    $('#fixed-expenses-money-form-modal #fixed-expenses-money-form-modal-title').text('Edit Fixed Expense');
                                    $('#fixed-expenses-money-form-modal input[name="id"]').val(item.id);
                                    $('#fixed-expenses-money-form-modal input[name="title"]').val(item.title);
                                    $('#fixed-expenses-money-form-modal input[name="default_value"]').val(item.default_value);
                                    $('#fixed-expenses-money-form-modal select[name="type"]').val(item.type);
                                    $('#fixed-expenses-money-form-modal select[name="term"]').val(item.term);
                                    $('#fixed-expenses-money-form-modal textarea[name="comment"]').val(item.comment);
                                    $('#fixed-expenses-money-form-modal input[name="list_id"]').val('fixed_expenses');
                                    $('#fixed-expenses-money-form-modal .hided').hide();
                                    $('#fixed-expenses-money-form-modal .hided-edit').hide();
                                    $('#fixed-expenses-money-form-modal .custom-control-label').hide();
                                    $('#fixed-expenses-money-form-modal #percent_label').hide();
                                    $('#fixed-expenses-money-form-modal #default_value_input').show();
                                    $('#fixed-expenses-money-form-modal #default_value_hided').show();
                                    $('#fixed-expenses-money-form-modal #default_value_label').show();
                                    $('#fixed-expenses-money-form-modal').modal('show');
                                    break;
                                case 'flexed_expenses':
                                    $('#fixed-expenses-money-form-modal #fixed-expenses-money-form-modal-title').text('Edit Flexed Expense');
                                    $('#fixed-expenses-money-form-modal input[name="id"]').val(item.id);
                                    $('#fixed-expenses-money-form-modal input[name="title"]').val(item.title);
                                    $('#fixed-expenses-money-form-modal input[name="percent"]').val(item.percent);
                                    $('#fixed-expenses-money-form-modal select[name="type"]').val(item.type);
                                    $('#fixed-expenses-money-form-modal select[name="link_to"]').val(item.link_to);
                                    $('#fixed-expenses-money-form-modal textarea[name="comment"]').val(item.comment);
                                    $('#fixed-expenses-money-form-modal input[name="list_id"]').val('flexed_expenses');
                                    $('#fixed-expenses-money-form-modal .hided').hide();
                                    $('#fixed-expenses-money-form-modal .hided-edit').hide();
                                    $('#fixed-expenses-money-form-modal .custom-control-label').hide();
                                    $('#fixed-expenses-money-form-modal #default_value_label').hide();
                                    $('#fixed-expenses-money-form-modal #percent_input').show();
                                    $('#fixed-expenses-money-form-modal #percent_hided').show();
                                    $('#fixed-expenses-money-form-modal #percent_label').show();
                                    $('#fixed-expenses-money-form-modal').modal('show');
                                    break;
                            }
                        }
                    },
                });
            });
        }
    },
    initMoneyDeletes() {
        let $this = this;
        $('body').on('click', '.money-delete-button', function () {
            let elem = $(this);
            let $confirm = confirm("You sure want to delete this?");
            if ($confirm) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                $.ajax({
                    type: 'DELETE',
                    url: '/money',
                    data: ({
                        id: elem.data('id'),
                        year: urlParams.get('year'),
                    }),
                    success: function (response) {
                        $('.money-table-wrapper').html(response.data);
                        elem.closest('.money-form-modal').modal('hide');
                        elem.data('id', '');
                        elem.hide();
                        $this.replaceSalesList(response.sales_list);
                    },
                });
            }
        });
    },
    initMoneyAdds() {
        $('body').on('click', '.money-table-wrapper .add-money-item', function (e) {
            e.preventDefault();
            $($(this).data('target') + ' form')[0].reset();
            $($(this).data('target') + ' form input[name="id"]').val('');
            let title;
            switch ($(this).data('target')) {
                case '#sales-money-form-modal':
                    title = 'Add new Sales / Revenue';
                    break;
                case '#fixed-expenses-money-form-modal':
                    title = 'Add new Expense';
                    break;
                // case '#flexed-expenses-money-form-modal':
                //     title = 'Add new Flexed Expense';
                //     break;
            }
            $($(this).data('target') + ' ' + $(this).data('target') + '-title').text(title);
            $($(this).data('target')).modal('show');
            $('#fixed-expenses-money-form-modal .hided').hide();
            $('#fixed-expenses-money-form-modal .hided-add').hide();
            $('#fixed-expenses-money-form-modal .hided-edit').show();
            $('#fixed-expenses-money-form-modal .custom-control-label').show();
        });
    },
    initShowInfo() {
        $('body').on('click', '.money-show-info', function (e) {
            e.preventDefault();
            $('.money-info-item').toggle();
        });
    },
    initFormModal(name) {
        let $this = this;
        if ($('#' + name + '-money-submit-form').length) {
            $('body').on('click', '#' + name + '-money-submit-form', function (e) {
                let data = $('#' + name + '-money-item').serialize();
                data += '&show_item_edit=' + $('input[name="show_item_edit"]').val();
                $.ajax({
                    type: 'POST',
                    url: '/money',
                    data: data,
                    success: function (response) {
                        $('.money-table-wrapper').html(response.data);
                        $('#' + name + '-money-form-modal').modal('hide');
                        $('#' + name + '-money-item')[0].reset();
                        $('#' + name + '-money-form .form-validation-errors').empty();
                        $this.replaceSalesList(response.sales_list);
                    },
                    error: function (response) {
                        if (response.responseJSON.error) {
                            $('#' + name + '-money-form .form-validation-errors').html('<div class="alert alert-danger">' + response.responseJSON.error + '</div>');
                        }
                        if (response.responseJSON.errors) {
                            let errorsHtml = '<div class="alert alert-danger">Some errors occurred:<br /><ul>';

                            $.each(response.responseJSON.errors, function (index, value) {
                                errorsHtml += '<li>' + value[0] + '</li>';
                            });
                            errorsHtml += '</ul></div>';

                            $('.' + name + '-money-form .form-validation-errors').html(errorsHtml);
                        }
                    },
                });
            });
        }
    },
    initSettingsMoneyItem() {
        $('body').on('click', function (e) {
            if (!$(e.target).closest('#money .settings').length) {
                $('#money .links').addClass('d-none');
            }
        });
        $('body').on('click', '#money .settings', function (e) {
            e.preventDefault();
            let money_item_id = $(this).data('id');
            if ($('#money #links-' + money_item_id).hasClass('d-none')) {
                $('.links').addClass('d-none');
                $('#money #links-' + money_item_id).removeClass('d-none');
            } else {
                $('#money #links-' + money_item_id).addClass('d-none');
            }
        });
    },
    moneyMonth(elem) {
        $.ajax({
            type: 'POST',
            url: '/money/money_month',
            data: ({
                id: elem.data('id'),
                value: elem.val(),
                month: elem.data('month'),
                item_id: elem.data('item-id'),
                year: $('#money-year').val(),
                show_item_edit: $('input[name="show_item_edit"]').val(),
            }),
            success: function (response) {
                //TODO remake this to recount total instead of loading complete table
                $('.money-table-wrapper').html(response.data);
            },
        });
    },
    changeValueType() {
        $('body').on('change', '#money #fixed-expenses-money-form-modal :checkbox', function(e) {
            e.preventDefault();
            $('#money #fixed-expenses-money-form-modal :checkbox').each(function(i, el) {
                $(el).prop('checked', false);
                $('#'+ this.id +'_input').val('');
                $('#'+ this.id +'_input').hide();
                $('#'+ this.id +'_hided').hide();
            });
            if ( $(this).prop('checked', true) ) {
                $('#'+ this.id +'_input').show();
                $('#'+ this.id +'_hided').show();
            }
            if (this.id == 'default_value') {
                $('#fixed-expenses-money-form-modal #fixed-expenses-money-form-modal-title').text('Add New Fixed Expense');
                $('#fixed-expenses-money-form-modal input[name="list_id"]').val('fixed_expenses');
            }else{
                $('#fixed-expenses-money-form-modal #fixed-expenses-money-form-modal-title').text('Add New Flexed Expense');
                $('#fixed-expenses-money-form-modal input[name="list_id"]').val('flexed_expenses');
            }
        });
    },
    replaceSalesList(sales_list) {
        let view = { 'sales_list': sales_list };
        let tmpl = $('#money_sales').html();
        let html = Mustache.render(tmpl, view);
        $('#flexed_expenses_link_to').html(html);
    },
};
